
import { TabStyles, TextLinkWidget } from '@tableau/widgets';
import { useFormikContext } from 'formik';
import React from 'react';

import { HelpService } from '~src/commonInfra/services/HelpService';
import { learnMoreStyle, SettingsStyles } from '~src/settings/styles/CommonStyles';
import { FeatureFlags } from '~src/ts/FeatureFlags';

import { SessionServerSelectors,SessionSiteSelectors } from '../../../../../app/selectors/SessionInfoSelectors';
import { Messages } from '../../../../../codegen/Localize';
import { FormikCheckbox } from '../../../../../commonInfra/components/FormikCheckbox';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import { useSelector } from '../../../utils';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { SiteSettingsForSiteAdminProps } from '../../site-settings/ReactSiteSettingsForSiteAdmin';

export type FlowSubscriptionsSiteSettingSectionProps = SiteSettingsForSiteAdminProps<'flowOutputSubscriptionSettings'>;

export const FLOW_SUBS_HELP_TOKEN = 'prep-conductor-subscribe-flow-output';

export const FLOW_SUBS_SITE_SETTINGS_TESTID = 'flow-subs-site-settings-test-id';
export const FLOW_SUBS_SITE_SETTINGS_HELP_TESTID = 'flow-subs-site-settings-help-test-id';
export const FLOW_SUBS_SITE_SETTINGS_EMAILS_CHECKBOX_TESTID = 'flow-subs-emails-checkbox-test-id';
export const FLOW_SUBS_SITE_SETTINGS_DATA_IN_EMAIL_BODY_CHECKBOX_TESTID = 'flow-subs-data-in-email-body-checkbox-test-id';
export const FLOW_SUBS_SITE_SETTINGS_EMAIL_ATTACHMENTS_CHECKBOX_TESTID = 'flow-subs-email-attachments-checkbox-test-id';

const FLOW_SUBS_ENABLED_SETTING = 'settings.flowOutputSubscriptionSettings.flowOutputSubscriptionsEnabled';
const FLOW_SUBS_DATA_IN_EMAIL_BODY_SETTING = 'settings.flowOutputSubscriptionSettings.flowOutputSubscriptionsDataInEmailBodyEnabled';
const FLOW_SUBS_EMAIL_ATTACHMENTS_SETTING = 'settings.flowOutputSubscriptionSettings.flowOutputSubscriptionsDataAsEmailAttachmentEnabled';

export function FlowSubscriptionsSiteSettingSection(props: FlowSubscriptionsSiteSettingSectionProps) {
  const prepConductorEnabled = useSelector(SessionSiteSelectors.isFlowOnSiteEnabled);
  const isOnline = useSelector(SessionServerSelectors.isOnlineEnvironment);
  const formik = useFormikContext<FlowSubscriptionsSiteSettingSectionProps>();
  return (FeatureFlags.flowOutputSubscriptionsV1Enabled && prepConductorEnabled ?
    <SettingsSection
      title={Messages.flowSubscriptionsSiteSettingsSectionTitle()}
      testId={FLOW_SUBS_SITE_SETTINGS_TESTID}
      description={
        <div>
          {Messages.flowSubscriptionsSiteSettingsSectionDescription()}
          <TextLinkWidget
            testId={FLOW_SUBS_SITE_SETTINGS_HELP_TESTID}
            target={'_blank'}
            className={learnMoreStyle}
            href={HelpService.getServerHelpUrlByCategory(FLOW_SUBS_HELP_TOKEN)}>
            {Messages.learnMore()}
          </TextLinkWidget>
        </div>
      }>
      <div className={SettingsStyles.checkboxGroup}>
        <FormikCheckbox
          name={FLOW_SUBS_ENABLED_SETTING}
          label={Messages.flowSubscriptionsSiteSettingsEnableCheckboxLabel()}
          testId={FLOW_SUBS_SITE_SETTINGS_EMAILS_CHECKBOX_TESTID}
        />
      </div>
      {(!isOnline ?
        <div className={SettingsStyles.checkboxGroup} style={{ paddingLeft: TabStyles.Spacing.LargeSpace }}>
          <FormikCheckbox
            name={FLOW_SUBS_DATA_IN_EMAIL_BODY_SETTING}
            label={Messages.flowSubscriptionsSiteSettingsDataInEmailBodyCheckboxLabel()}
            testId={FLOW_SUBS_SITE_SETTINGS_DATA_IN_EMAIL_BODY_CHECKBOX_TESTID}
            checked={formik.values.settings.flowOutputSubscriptionSettings?.flowOutputSubscriptionsEnabled && formik.values.settings.flowOutputSubscriptionSettings?.flowOutputSubscriptionsDataInEmailBodyEnabled}
            disabled={!formik.values.settings.flowOutputSubscriptionSettings?.flowOutputSubscriptionsEnabled}
          />
          <FormikCheckbox
            name={FLOW_SUBS_EMAIL_ATTACHMENTS_SETTING}
            label={Messages.flowSubscriptionsSiteSettingsEmailAttachmentsCheckboxLabel()}
            testId={FLOW_SUBS_SITE_SETTINGS_EMAIL_ATTACHMENTS_CHECKBOX_TESTID}
            checked={formik.values.settings.flowOutputSubscriptionSettings?.flowOutputSubscriptionsEnabled && formik.values.settings.flowOutputSubscriptionSettings?.flowOutputSubscriptionsDataAsEmailAttachmentEnabled}
            disabled={!formik.values.settings.flowOutputSubscriptionSettings?.flowOutputSubscriptionsEnabled}
          />
        </div> : null
      )}
    </SettingsSection> : null
  );
}

/* for registering the component in settings registry */
export const FlowSubscriptionsSiteSettingSpecs = componentRegistryEntry({
  name: 'FlowSubscriptionsSiteSettingSection',
  component: FlowSubscriptionsSiteSettingSection
});
